import React from 'react';

export default function TextConditionsPeru({ nombre, razonSocial, emailContacto }) {
  return (
    <div className='text-sm text-gray-400 font-bold'>
      <section className='mb-8'>
        <p>
          Conforme a la Ley N° 29733 – Ley de Protección de Datos Personales, su Reglamento
          aprobado mediante D. Sup. N° 003-2013-JUS y las demás disposiciones complementarias,
          declaro, mi consentimiento libre y expreso, a favor de {nombre}, respecto a la información
          brindada (presencial, oral, telefónica, página web, redes sociales y otros) para dar
          tratamiento de mis datos personales y/o de la información que facilito de terceros previo
          consentimiento de éstos y en caso sean menores de edad, declaro contar con las facultades
          de representación, así también doy mi consentimiento que la información personal que{' '}
          {razonSocial}, obtenga de sus entidades afiliadas, socios comerciales y otras fuentes de
          terceros independientes, sea añadida a mi información personal brindada.
        </p>
      </section>

      <section className='mb-8'>
        <p>
          El responsable del banco de datos, será {nombre}, quien podrá compartir dicha información
          con las sociedades subsidiarias afiliadas o vinculadas a una sociedad matriz o a
          cualquier sociedad del mismo grupo económico sea nacional o internacional.
        </p>
      </section>

      <section className='mb-8'>
        <p>
          {nombre} podrá incorporar mi información a los bancos de datos personales que correspondan
          debidamente inscritos ante la Autoridad Nacional de Protección de Datos Personales
          almacenarla, darle tratamiento y procesarla a efectos de: enviarme invitaciones a eventos,
          Fam Trips, campañas, envío de flyer, por correo, presencial o digital (Redes Sociales,
          Correos electrónicos, etc.), comunicación vía telefónica (llamada o mensajería como
          WhatsApp, SMS), o escrita, campañas, sorteos y/o concursos, que ofrezca.
        </p>
      </section>

      <section className='mb-8'>
        <p>
          Declaro haber sido informado que mis datos personales serán conservados después de que
          finalice la relación comercial con {nombre}. Asimismo, he sido informado, que puedo
          ejercer mis derechos de acceso, rectificación, cancelación, oposición y revocación siempre
          que cumpla con los requisitos exigidos por las normas aplicables, dirigiéndome a{' '}
          {nombre} a la dirección de correo electrónico:
        </p>
      </section>

      <section className='mb-8'>{emailContacto}</section>

      <section className='mb-8'>
        <p>
          Finalmente, declaro expresamente, que antes de brindar mi consentimiento, fui informado
          previamente en forma clara e inequívoca de las finalidades que tendrá el tratamiento de
          mis datos personales, conforme los términos arriba expuestos y que las mismas serán
          tratadas de conformidad con las disposiciones de política de privacidad.
        </p>
      </section>
    </div>
  );
}
